import { Box, Tag, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import {
  addMonths,
  differenceInDays,
  differenceInWeeks,
  formatDistanceStrict,
  isBefore,
} from 'date-fns'

import i18n from 'modules/core/lib/i18n'

type TagColor = 'tangerine' | 'transparent' | 'radical' | 'grey4'

const CompletionTag = ({ dueDate }: { dueDate: string }) => {
  const [openTooltip, toggleTooltip] = useToggle()
  const today = new Date()
  const dueDateObj = new Date(dueDate)

  const timeDifferenceText = (days: number, weeks: number) => {
    if (days < 7) {
      return i18n.tp('trainings.trainings_revamp.training_detail.employees_table.due_date.days', {
        count: days,
      })
    } else if (days < 30) {
      return i18n.tp('trainings.trainings_revamp.training_detail.employees_table.due_date.weeks', {
        count: weeks,
      })
    } else {
      return `${i18n.t(
        'trainings.trainings_revamp.training_detail.employees_table.due_date.in'
      )} ${formatDistanceStrict(dueDateObj, today)}`
    }
  }

  const isOverdue = isBefore(dueDateObj, today)

  const tagStrategies = {
    overdue: {
      getTagText: () =>
        i18n.t('trainings.trainings_revamp.training_detail.employees_table.due_date.overdue'),
      getTagColor: (): TagColor => 'radical',
    },
    nearDueDate: {
      getTagText: (dateObj: Date, dateToday: Date) => {
        const daysDifference = differenceInDays(dateObj, dateToday)
        const weeksDifference = differenceInWeeks(dateObj, dateToday)
        return timeDifferenceText(daysDifference, weeksDifference)
      },
      getTagColor: (): TagColor => 'tangerine',
    },
    farDueDate: {
      getTagText: (dateObj: Date, dateToday: Date) => {
        return `${i18n.t(
          'trainings.trainings_revamp.training_detail.employees_table.due_date.in'
        )} ${formatDistanceStrict(dateObj, dateToday)}`
      },
      getTagColor: (dateObj: Date, dateToday: Date): TagColor => {
        return isBefore(dateObj, addMonths(dateToday, 3)) ? 'tangerine' : 'grey4'
      },
    },
  }

  const strategy = isOverdue
    ? tagStrategies.overdue
    : differenceInDays(dueDateObj, today) < 30
    ? tagStrategies.nearDueDate
    : tagStrategies.farDueDate

  const tagText = strategy.getTagText(dueDateObj, today)
  const tagColor = strategy.getTagColor(dueDateObj, today)
  const dateOptions: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }
  const formatedDate = dueDateObj.toLocaleDateString(undefined, dateOptions)

  return (
    <Box width="fit-content">
      <Tooltip.Dialog
        label={formatedDate}
        attachment="bottom left"
        open={openTooltip}
        toggle={toggleTooltip}
      >
        <Tag type={tagColor}>{tagText}</Tag>
      </Tooltip.Dialog>
    </Box>
  )
}

export default CompletionTag
